export default "__VITE_ASSET__CtY_klhC__"